import { Color } from '@persona-id/design-tokens';
import { CircleHelpIcon } from '@persona-id/design-tokens/icons';
import { CircleHelpIcon as CircleHelpIconSmall } from '@persona-id/design-tokens/icons/12px';
import { ReactNode } from 'react';

import Tooltip, { TooltipWithIconProps } from 'design-system/components/Tooltip/Tooltip';

export interface HelperTooltipProps extends Omit<TooltipWithIconProps, 'iconTrigger'> {
  children: ReactNode;
  size?: 'md' | 'sm';
}

/**
 * Helper component for rendering help text via help icons.
 */
const HelperTooltip = ({ children, size = 'md', ...props }: HelperTooltipProps) => {
  return (
    <Tooltip
      iconTrigger={
        size === 'md' ? (
          <CircleHelpIcon color={Color.BorderIconSecondary} />
        ) : (
          <CircleHelpIconSmall color={Color.BorderIconSecondary} />
        )
      }
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default HelperTooltip;
